import React from "react";
import { Button, Modal } from "antd";

import TextInfo from "../../../../../components/common/TextInfo/TextInfo";

import "../../../../../components/common/styles.css";
import { CanAccess } from "../../../../../components/template/authorization/Authorization";

const ProcessBiddingDialog = ({
  visible,
  handleCancel,
  handleSave,
  onInputChange,
  errors,
  data,
  handleSavePermissions = true,
}) => {
  const handleChange =
    (type, field = "") =>
    (event) => {
      if (type === "number") {
        onInputChange(field, event.value, "processBidding");
      } else if (type === "input") {
        const { name, value } = event.target;
        onInputChange(name, value, "processBidding");
      }
    };

  return (
    <Modal
      className="modal-form"
      title="Proses Penawaran"
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <CanAccess
          role={handleSavePermissions}
          yes={
            <Button
              key="submit"
              type="primary"
              onClick={handleSave}
              className="btn-modal"
            >
              Simpan
            </Button>
          }
        />,
      ]}
    >
      <div className="modal-form-content">
        <TextInfo
          title="Pilih Tujuan Lelang"
          type={"radio"}
          id={"destination"}
          handleChange={handleChange("input")}
          error={errors?.destination}
          value={data.destination}
          radioData={[
            {
              label: "E-Boutique",
              value: "E-Boutique",
            },
            {
              label: "Mitra",
              value: "Mitra",
            },
          ]}
          isForm
        />
        <TextInfo
          title="Link Penawaran"
          value={data.offeringLink}
          type={"input"}
          id={"offeringLink"}
          handleChange={handleChange("input")}
          error={errors?.offeringLink}
          placeholder={"Masukkan Link Penawaran"}
          isForm
        />
      </div>
    </Modal>
  );
};

export default ProcessBiddingDialog;
